










































import { container } from "@/inversify.config";
import IAlertService from "fs-pb-vue2/services/alert/IAlertService";
import { DiTokens } from "fs-pb-vue2/services/diTokens";
import { Component, Vue, Prop } from "vue-property-decorator";

interface PinPadItem {
  fabType: boolean,
  className: string,
  isIcon: boolean,
  text: string | undefined,
  action: Function | undefined,
  visibility: Function,
  disabled: Function
}
@Component({
})
export default class LoginWithoutPassword extends Vue {

  @Prop() title!: string;

  @Prop() cancelBtnName!: string;

  get titleValue(): string {
    return this.title || "Введите PIN-код";
  }

  get cancelBtnNameValue(): string {
    return this.cancelBtnName || "Выйти";
  }

  /**Ссылка на службу уведомленний */
  get alertService(): IAlertService {
    return container.get<IAlertService>(DiTokens.AlertService);
  }

  pin: string = ""

  progress: any = [];

  pinLength: number = 4;

  progressEmptyArr: Array<number> = [];

  pinPad: Array<Array<PinPadItem>> = [];

  disableNumPad: boolean = false;

  loading: boolean = false;

  getCredentialDefaultArgs: any = {
    publicKey: {
      timeout: 60000,
      allowCredentials: [], // see below
      challenge: [],
      userVerification: 'required',
      rpId: window.location.host
    },
  };

  constructor() {
    super();
    for (let i: number = 0; i < this.pinLength; i++) {
      this.progressEmptyArr.push(i);
    }

    const stringLength: number = 3;
    for (let i: number = 0; i < stringLength; i++) {
      const pinPadString: Array<PinPadItem> = [];
      for (let k: number = 1; k < stringLength + 1; k++) {
        const num: number = k + i * stringLength;
        pinPadString.push({
          className: "pin-number",
          fabType: true,
          isIcon: false,
          text: num.toString(),
          action: () => { this.clickNumPadNum(num); },
          visibility: () => true,
          disabled: () => this.disableNumPad
        });
      }
      this.pinPad.push(pinPadString);
    }
  }

  mounted() {
    const pinPadString: Array<PinPadItem> = [];
    pinPadString.push({
      className: "pin-grey-btn pin-text",
      fabType: false,
      isIcon: false,
      text: this.cancelBtnNameValue,
      action: this.cancel,
      visibility: () => true,
      disabled: () => false
    });
    pinPadString.push({
      className: "pin-number",
      fabType: true,
      isIcon: false,
      text: (0).toString(),
      action: () => { this.clickNumPadNum(0); },
      visibility: () => true,
      disabled: () => this.disableNumPad
    });
    pinPadString.push({
      className: "pin-grey-btn",
      fabType: false,
      isIcon: true,
      text: "mdi-backspace",
      action: this.clear,
      visibility: () => !!this.progress.length,
      disabled: () => false
    });
    this.pinPad.push(pinPadString);
  }

  get withBIO(): boolean {
    return this.$route.path === '/login' && !!window.localStorage.getItem('BIOinf');
  }

  openBIO = async () => {
    if (navigator && navigator.credentials) {
      if (!window.localStorage.getItem('BIOinf')) {
        return;
      }
      if (!window.localStorage.getItem('authBIO')) {
        const regResult: boolean = await this.registerBIO();
        if (!regResult)
          return;
      }
      try {
        const stringBuffer = window.localStorage.getItem('authBIO');
        this.getCredentialDefaultArgs.publicKey.challenge = new TextEncoder().encode(stringBuffer);
        const authRes = await navigator.credentials.get(this.getCredentialDefaultArgs);
        if (authRes) {
          const pinCode: string = this.$CryptoJS.AES.decrypt(window.localStorage.getItem('BIOinf'), process.env.VUE_APP_PHRASE).toString(this.$CryptoJS.enc.Utf8);
          this.$emit("onExecute", pinCode);
        }
      } catch(e: any) {
        console.log(e);
        this.alertService.error('Авторизация не пройдена');
      }
    } else {
      this.alertService.error('Браузер не поддерживает данный метод авторизации');
      return false;
    }
  }

  createGuid(): string {  
    return "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx".replace(/x/g, function (c) {
        const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    }); 
  }

  get deviceGUID(): string {
    return window.localStorage.getItem('deviceId');
  }

  async registerBIO(): Promise<boolean> {
    try {
      const challenge = new Uint8Array([
        // must be a cryptographically random number sent from a server
        0x8c, 0x0a, 0x26, 0xff, 0x22, 0x91, 0xc1, 0xe9, 0xb9, 0x4e, 0x2e, 0x17, 0x1a,
        0x98, 0x6a, 0x73, 0x71, 0x9d, 0x43, 0x48, 0xd5, 0xa7, 0x6a, 0x15, 0x7e, 0x38,
        0x94, 0x52, 0x77, 0x97, 0x0f, 0xef,
      ]).buffer;
      const res = await navigator.credentials.create({
        publicKey: {
          authenticatorAttachment: 'platofrm',
          requireResidentKey: true,
          residentKey: "required",
          // Relying Party (a.k.a. - Service):
          rp: { id: window.location.host, name: window.location.host },
          // User:
          user: {
            id: new Uint8Array(16),
            name: window.localStorage.getItem('loginValue'),
            displayName: window.localStorage.getItem('loginValue'),
          },
          attestation: "none",      
          pubKeyCredParams: [
            {
              type: 'public-key',
              alg: -7,
            },
            {
              type: 'public-key',
              alg: -8,
            },
            {
              type: 'public-key',
              alg: -257,
            }
          ],
          timeout: 60000,
          excludeCredentials: [],
          authenticatorSelection: {
            residentKey: 'preferred',
            requireResidentKey: false,
            userVerification: 'required',
          },
          extensions: {
            credProps: true,
          },
          challenge: challenge,
        }
      })
      if (res && res.id) {
        //const guid: string = this.createGuid();

        window.localStorage.setItem('authBIO', new TextDecoder().decode(challenge));
        return true;

        //this.alertService('Ключ пара зарегистрирована!');

        //this.getCredentialDefaultArgs.publicKey.allowCredentials = idList;

        //await this.authBIO();
      }  
    } catch (e: any) {
      this.alertService.error('Не удалось зарегистрировать данные пользователя');
      console.log(e);
      console.log(e.code);
      return false;
    }
  }


  clickNumPadNum = (num: number) => {
    if (this.disableNumPad || this.progress.length == this.pinLength)
      return;
    this.progress.push(num);

    if (this.progress.length == this.pinLength) {
      this.disableNumPad = true;
      this.execute();
    }
  }

  clear = () => {
    this.progress.pop();
    this.disableNumPad = false;
  }

  execute = () => {
    this.pin = "";
    this.progress.forEach((element: number) => {
      this.pin += element.toString();
    });
    this.loading = true;
    for(let i = 0; i< this.pinLength; i++) {
      this.progress.pop();
      this.disableNumPad = false;
    }
    this.$emit("onExecute", this.pin);
  }

  cancel = () => {
    this.$emit("onCancel");
  }
}
